var React = require('react');

function CircleCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"}));
}

CircleCheck.defaultProps = {"className":"h-6 w-6","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","strokeWidth":"2"};

module.exports = CircleCheck;

CircleCheck.default = CircleCheck;
